export async function fetchWalletBalance(apiClient, chain, address) {
  const { data } = await apiClient.get(`/wallet/balance/${chain}/${address}`);
  return data.balance;
}
